import type { ICellRendererParams } from 'ag-grid-community';
import { Avatar } from 'Components/atoms';
import { USERS_DASHBOARD_ROUTE } from 'Core-utils/routes';
import { Link } from 'react-router-dom';
import React from 'react';
import type { Employee } from './usersTable';

/**
 * User name cell — avatar + full name, linking to the user dashboard (legacy table behavior).
 */
const UsersNameCellRenderer: React.FC<ICellRendererParams<Employee>> = (params) => {
  const row = params.data;
  if (!row) {
    return null;
  }
  return (
    <Link
      className="text-decoration-none data-grid__link d-flex align-items-center h-100"
      to={`${USERS_DASHBOARD_ROUTE}/${row.id}`}
    >
      <Avatar variant="name_avatar" name={row.name} image={row.image} />
    </Link>
  );
};

export default UsersNameCellRenderer;
